<template>
  <div class="page-view videos">
    <template v-if="t.videosMenu">
      <div class="side-menu" :class="{
        'mobile':width<760
      }">
        <!-- burger-menu -->
        <div v-if="width<760" class="burger-menu-wrap">
          <span
            @click="open=!open"
            :class="{
              'burger-menu': true,
              'diginity':true,
              'dg-list':!open,
              'dg-close':open
            }"
          ></span>
        </div>
        <ul
          v-if="t.videosMenu"
          :class="{
            'menu-list':true,
            'hamburger':width<760,
            'open':open
          }"
        >
          <li
            v-for="(p,i) in t.videosMenu.parent"
            :key="i"
            :class="{
              'menu-btn':true,
              'active': isChild(p.id)
            }"
          >
            <!-- have child -->
            <router-link
              v-if="!isChild(p.id)"
              :to="`/${lng}/videos/${p.position}`"
              :class="{
                'active': exact(p.position)
              }"
            >{{ p.key }}</router-link>
            <!--// haven't child -->
            <a v-else href="javascript:;" class="non_route">{{ p.key }}</a>
            <template v-if="isChild(p.id)">
              <!-- mobile -->
              <div class="mobile-menu" v-if="width<760">
                <button class="diginity dg-left-arrow-thin" id="slide-nav__prev"></button>
                <swiper class="swiper" :options="options">
                  <swiper-slide
                    v-for="(c,i) in t.videosMenu.child"
                    :key="i"
                    v-if="c.parent == p.id"
                  >
                    <router-link
                      :to="`/${lng}/videos/${c.position}`"
                      :class="{
                        'active': exact(c.position)
                      }"
                    >{{ c.key }}</router-link>
                  </swiper-slide>
                </swiper>
                <button class="diginity dg-right-arrow-thin" id="slide-nav__next"></button>
              </div>
              <!-- desktop -->
              <ul v-else class="dropdown">
                <li v-for="(c,i) in t.videosMenu.child" :key="i" v-if="c.parent == p.id">
                  <router-link
                    :to="`/${lng}/videos/${c.position}`"
                    :class="{
                      'active': exact(c.position)
                    }"
                  >{{ c.key }}</router-link>
                </li>
              </ul>
            </template>
          </li>
        </ul>
      </div>
      <template v-if="Array.isArray(videos_list)&&videos_list.length">
        <keep-alive>
          <router-view :menu="propMenu" />
        </keep-alive>
        <transition name="fade">
          <router-view name="id" />
        </transition>
      </template>
      <!-- videos-list loading -->
      <template v-else>
        <div class="spinner" v-if="Array.isArray(videos_list) && !videos_list.length">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
        <p class="response-error" v-if="videos_list==undefined">
          <span>{{ lng == 'tr' ? 'Kayıt bulunamadı' : 'No Records Found' }}</span>
        </p>
      </template>
    </template>
    <!-- videos-menu loadng -->
    <template v-else>
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      width: window.innerWidth,
      open: false,
      options: {
        slidesPerView: 3,
        navigation: {
          nextEl: "#slide-nav__next",
          prevEl: "#slide-nav__prev"
        },
        breakpoints: {
          400: {
            slidesPerView: 1
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters(["t", "lng", "videos_list"]),
    propMenu() {
      return this.getID(this.$route.params.type);
    }
  },
  beforeMount() {
    const _ = this;
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        _.width = window.innerWidth;
      });
    });
    if (this.t.videosMenu) {
      this.$store.dispatch(
        "videos_list",
        this.getID(this.$route.params.type).id
      );
    }
  },
  methods: {
    isChild(id) {
      return this.t.videosMenu.child.filter(a => {
        return a.parent == id;
      }).length;
    },
    getID(position) {
      const menu = this.t.videosMenu.params.find(item => {
        return position == item.position;
      });
      return menu;
    },
    exact(value) {
      return this.$route.params.type == value;
    }
  },
  watch: {
    "t.videosMenu"(newValue, oldValue) {
      this.$store.dispatch(
        "videos_list",
        this.getID(this.$route.params.type).id
      );
    },
    $route(newValue, oldValue) {
      if (oldValue.params.type !== newValue.params.type) {
        this.$store.dispatch(
          "videos_list",
          this.getID(newValue.params.type).id
        );
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/colors";
.page-view {
  background: #e7e7e7;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  /*  CONTENT */
  .content {
    flex: 1;
    position: relative;
    padding: 10px 20px;
    @media screen and (max-width: 760px) {
      flex: 1 auto;
    }
  }
}
.videos {
  .mobile-menu {
    display: flex;
    flex-wrap: nowrap;
    padding: 5px 0;
    button {
      background: none;
      border: none;
      color: $main;
      padding: 5px;
      outline: none;
      font-size: 20px;
      cursor: pointer;
      &.swiper-button-disabled {
        color: #ccc;
      }
    }
    .active {
      color: $main;
      font-weight: bold;
    }
    .swiper {
      flex: 1 auto;
      .swiper-slide {
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          width: 90%;
          height: 100%;
          &:hover {
            color: $main;
            background: #ddd;
          }
        }
      }
    }
    &.swiper-button-disabled {
      display: none;
    }
  }
  .non_route {
    cursor: default !important;
  }
  .side-menu {
    min-width: 260px;
    padding: 30px 5px 10px;
    &.mobile {
      width: 100%;
    }
    ul.menu-list {
      // mobile menu
      @media screen and (max-width: 760px) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
      }
      &.hamburger {
        display: none;
        &.open {
          display: block !important;
        }
      }
      li.menu-btn {
        margin: 5px;
        @media screen and (max-width: 760px) {
          width: 100%;
        }
        & > a {
          color: #8a8b8d;
          text-align: left;
          padding: 7px;
          font-size: 14px;
          display: block;
          &.active {
            color: $main;
            &:hover:not(.non_route) {
              color: $main;
            }
          }
          &:hover:not(.non_route) {
            color: #606266;
          }
        }
        &.active {
          ul.dropdown {
            display: block;
            padding-left: 20px;
          }
        }
        ul.dropdown {
          padding: 5px 0;
          display: none;
          li {
            a {
              color: #8a8b8d;
              display: block;
              font-size: 14px;
              padding: 5px 8px;
              font-weight: 500;
              &:hover {
                color: #606266;
              }
              &.active {
                color: $main !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
